import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeOffOutline = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3.25 3.25 20.75 20.75" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.6 6.05A9.9 9.9 0 0 1 12 5.95c5.75 0 9.25 6.05 9.25 6.05a17.7 17.7 0 0 1-2.4 3.2" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.7 7.7A17.6 17.6 0 0 0 2.75 12S6.25 18.05 12 18.05a9.7 9.7 0 0 0 3.35-.58" }),
		/* @__PURE__ */ _jsx("path", { d: "M9.9 9.9a3 3 0 0 0 4.2 4.2" })
	]
});
const ForwardRef = forwardRef(SvgEyeOffOutline);
export default ForwardRef;
